module.exports = __webpack_public_path__ + "static/media/3.04afe330.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/3.png
// module id = 397
// module chunks = 0